<template>
  <el-dialog
      :model-value="visible"
      @update:model-value="$emit('update:visible', $event)"
      title="图书纠错"
      width="60%"
      top="7vh"
      @closed="resetForm"
  >
    <!-- 第一个表单：展示 ISBN -->
    <el-form label-width="100px" size="small">
      <el-row :gutter="20">
        <el-col>
          <el-form :inline="true" label-width="100px">
            <el-form-item label="ISBN" prop="title">
              {{ isbn }}
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-form>
    <!-- 第二个表单：书目字段 -->
    <el-form
        ref="tsDataForm"
        label-width="100px"
        size="small"
        :rules="tsRules"
        :model="formLRTSModel">
      <el-row>
        <el-col :span="8" style="border: #cccccc">
          <el-form-item label="封面:">
            <el-upload
                class="avatar-uploader"
                :class="{ disabled: uploadDisabled }"
                :headers="picheaders"
                :data="uploadtype"
                :action="uploadUrl"
                list-type="picture-card"
                :before-upload="beforeUpload"
                :on-preview="handlePictureCardPreview"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :on-success="handleSuccess"
                accept=".jpg,.jpeg,.png"
                :file-list="fileList">
              <i class="el-icon-plus"/>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="正题名" prop="Title">
            <el-input v-model="formLRTSModel.Title" placeholder="请填写正题名"/>
          </el-form-item>
          <el-form-item label="第一责任者" prop="Author">
            <el-input v-model="formLRTSModel.Author" placeholder="请填写第一责任者"/>
          </el-form-item>
          <el-form-item label="其他责任者">
            <el-input v-model="formLRTSModel.OtherResponsible" class="input-with-select" placeholder="请填写其他责任者"/>
          </el-form-item>
          <el-form-item label="分类号" prop="Class">
            <el-input v-model="formLRTSModel.Class" placeholder="请填写分类号"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="装订">
            <el-input v-model="formLRTSModel.Binding" placeholder="请填写装订"/>
          </el-form-item>
          <el-form-item label="卷页数">
            <el-input v-model="formLRTSModel.Page" placeholder="请填写卷页数"/>
          </el-form-item>
          <el-form-item label="副题名">
            <el-input v-model="formLRTSModel.Subtitle" placeholder="请填写副题名"/>
          </el-form-item>
          <el-form-item label="主题词">
            <el-input v-model="formLRTSModel.Keyword" placeholder="请填写主题词"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="版本">
            <el-input v-model="formLRTSModel.Edition" placeholder="请填写版本"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="卷册名">
            <el-input v-model="formLRTSModel.SectionNum" placeholder="请填写卷册名"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="丛书题名">
            <el-input v-model="formLRTSModel.SeriesTitle" placeholder="请填写丛书题名"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="卷册">
            <el-input v-model="formLRTSModel.SectionName" placeholder="请填写卷册"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出版日期">
            <el-input v-model="formLRTSModel.Pubdate" placeholder="请填写出版日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出版地">
            <el-input v-model="formLRTSModel.Pubplace" placeholder="请填写出版地"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出版社">
            <el-input v-model="formLRTSModel.Publisher" placeholder="请填写出版社"/>
          </el-form-item>
          <el-form-item label="每册价格" prop="Price">
            <el-input v-model="formLRTSModel.Price" placeholder="请填写每册价格"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="附注">
            <el-input v-model="formLRTSModel.Annotations" placeholder="请填写附注"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="简介">
            <el-input type="textarea" rows="4" v-model="formLRTSModel.Summary" placeholder="请填写简介"/>
          </el-form-item>
        </el-col>
        <el-col :span="22">
        </el-col>
        <span class="dialog-footer" style="float: right">
          <el-button size="small" type="primary" @click="sureErrorModify">确定</el-button>
        </span>
      </el-row>
    </el-form>
    </el-dialog>
    <!-- 占位：保证 .el-upload 元素始终存在于文档中，避免 uploadDisabled 首次计算时
         querySelector('.el-upload') 返回 null 而抛错（el-dialog 内容是懒渲染的） -->
    <div class="el-upload"></div>
</template>

<script>
import md5 from "js-md5";
import Compressor from "compressorjs";
import global from "@/utils/global";
import {BASE_URL} from "@/utils/constants";

export default {
  name: "BookErrorCorrectionDialog",
  props: {
    // 弹窗是否可见，配合 v-model:visible 使用
    visible: {
      type: Boolean,
      default: false,
    },
    // 要纠错的 ISBN
    isbn: {
      type: String,
      default: "",
    },
  },
  emits: ["update:visible", "success"],
  data() {
    var validatePrice = (rule, value, callback) => {
      const regex = /^\d+(\.\d{1,2})?$/;
      if (value === '') {
        callback(new Error('请输入价格'));
      } else if (!regex.test(value)) {
        callback(new Error('请输入纯数字或包含一位小数的数字'));
      } else {
        callback();
      }
    };
    return {
      formLRTSModel: {},
      uploadtype: {
        type: 'image/bookcover'
      },
      picheaders: {},
      uploadUrl: "",
      fileList: [],
      tsRules: {
        Title: [{required: true, message: "请输入正题名", trigger: "blur"}],
        Author: [{required: true, message: "请输入第一责任者", trigger: "blur"}],
        Class: [{required: true, message: "请输入分类号", trigger: "blur"}],
        Price: [{validator: validatePrice, trigger: "blur", required: true}],
        ISBN: [{required: true, message: "请输入ISBN", trigger: "blur"}],
      },
    };
  },
  computed: {
    uploadDisabled: function () {
      const uploadElement = document.querySelector('.el-upload');
      if (!uploadElement) {
        return this.fileList.length > 0;
      }
      if (this.fileList.length > 0) {
        uploadElement.style.display = 'none';
        return true;
      } else {
        uploadElement.style.display = 'inline-block';
        return false;
      }
    },
  },
  watch: {
    visible(val) {
      // 弹窗打开且带有 ISBN 时，加载图书详情
      if (val && this.isbn) {
        this.loadDetail(this.isbn);
      }
    },
  },
  created() {
    this.uploadUrl = global.syOssUrl + '/upload2Oss';
  },
  methods: {
    // 加载图书详情
    loadDetail(isbn) {
      if (!isbn || (isbn.length !== 10 && isbn.length !== 13)) {
        return this.$message.error("ISBN号不正确");
      }
      this.$axios({
        url: BASE_URL + "system/isbn/" + isbn,
        method: "get",
        headers: {
          "Content-Type": "application/json",
          dataType: "json",
          Authorization: localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          const m = res.data.msg;
          this.formLRTSModel = {
            Title: m.Title,
            Annotations: m.Annotations,
            OtherResponsible: m.OtherResponsible,
            SectionNum: m.SectionNum,
            SectionName: m.SectionName,
            SeriesTitle: m.SeriesTitle,
            Subtitle: m.Subtitle,
            Author: m.Author,
            Binding: m.Binding,
            Page: m.Page != null ? m.Page.toString() : "",
            ISBN: m.ISBN,
            Pubdate: m.Pubdate,
            Pubplace: m.Pubplace,
            Publisher: m.Publisher,
            Keyword: m.Keyword,
            Class: m.Class,
            Price: m.Price,
            Edition: m.Edition,
            Summary: m.Summary,
            Cover: m.Cover,
          };
          this.fileList = [];
          this.toSetCover(this.formLRTSModel.Cover, this.formLRTSModel.ISBN);
        } else {
          this.$notify({
            message: res.data.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    // 保存修改
    sureErrorModify() {
      this.formLRTSModel.Price = this.formLRTSModel.Price.toString();
      this.$refs["tsDataForm"].validate((valid) => {
        if (valid) {
          this.$axios({
            url: BASE_URL + "system/modifyIsbnInfo",
            method: "post",
            data: JSON.stringify(this.formLRTSModel),
            headers: {
              "Content-Type": "application/json",
              dataType: "json",
              Authorization: localStorage.getItem("token"),
            },
          }).then((res) => {
            if (res.data.ok) {
              this.$message({message: res.data.msg, type: "success"});
              this.$emit("success");
              this.$emit("update:visible", false);
            } else {
              this.$message({message: res.data.msg, type: "error"});
            }
          });
        }
      });
    },
    // 弹窗关闭后清空，避免下次打开闪现旧数据
    resetForm() {
      this.formLRTSModel = {};
      this.fileList = [];
    },
    //设置图片URL
    toSetCover(coverUrl, ISBN) {
      const defaultCover = require('../assets/img/defaultBook.png');
      if (coverUrl !== "") {
        this.fileList = [];
        this.checkImage(coverUrl)
            .then((result) => {
              this.fileList.push({url: result ? coverUrl : defaultCover});
            })
            .catch(() => {
              this.fileList.push({url: defaultCover});
            });
      } else {
        const imgsrc = 'https://sanyue-oss-public.oss-cn-hangzhou.aliyuncs.com/image/bookcover/' + ISBN + '.jpg';
        this.checkImage(imgsrc)
            .then((result) => {
              this.fileList.push({url: result ? imgsrc : defaultCover});
            })
            .catch(() => {
              this.fileList.push({url: defaultCover});
            });
      }
    },
    checkImage(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = function () {
          resolve(true);
        };
        img.onerror = function () {
          resolve(false);
        };
        img.src = url;
      });
    },
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg.toLowerCase() === 'jpg'
      const extension2 = testmsg.toLowerCase() === 'jepg'
      const extension3 = testmsg.toLowerCase() === 'png'
      if (!extension && !extension2 && !extension3) {
        this.$message({message: '上传图片只能是jpg/jepg/png格式!', type: 'warning'});
        return false
      }
      return new Promise((resolve, reject) => {
        this.now = Date.parse(new Date()) / 1000;
        this.picheaders = {
          'timestamp': this.now,
          'sign': md5('6486b66b41f8df68777eac23' + this.now)
        },
            new Compressor(file, {
              quality: 0.6,
              success(result) {
                resolve(result);
              },
              error(err) {
                reject(err);
              },
            });
      });
    },
    handlePictureCardPreview(file) {
      window.open(file.url)
    },
    handleChange(file, fileList) {
      this.fileList = fileList
    },
    handleRemove(file, fileList) {
      this.formLRTSModel.Cover = ''
      setTimeout(() => {
        this.fileList = fileList
      }, 1000);
    },
    handleSuccess(response, file, fileList) {
      if (response.code === 0) {
        this.fileList = fileList
        this.formLRTSModel.Cover = response.msg
      }
    },
  }
}
</script>

<style scoped>
.el-upload {

}
</style>
